export default __webpack_public_path__ + "static/media/cloud.019478fa.svg";